import ImageOne from '../images/circuloVerde.jpg';
import ImageTwo from '../images/galleon.jpg';

export const InfoData = {
  heading: 'Explore Circulo Verde',
  paragraphOne:
    ' Lorem, ipsum dolor sit amet consectetur adipisicing elit. Enim, sed.',
  paragraphTwo:
    'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi animi corrupti odit atque illum. Ducimus.',
  buttonLabel: 'View Estate',
  image: ImageOne,
  reverse: false,
  delay: 100,
};

export const InfoDataTwo = {
  heading: 'Explore Ortigas Center',
  paragraphOne:
    ' Lorem, ipsum dolor sit amet consectetur adipisicing elit. Enim, sed.',
  paragraphTwo:
    'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi animi corrupti odit atque illum. Ducimus.',
  buttonLabel: 'View Estate',
  image: ImageTwo,
  reverse: true,
  delay: 300,
};
